import { render, staticRenderFns } from "./SavedMoneyImport.vue?vue&type=template&id=00abafce"
import script from "./SavedMoneyImport.vue?vue&type=script&lang=js"
export * from "./SavedMoneyImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports